module.exports = __webpack_public_path__ + "media/images/icons/outlined/zhihu-a6f5d186c1c94eb2213c98eacda0f887.svg";